/** Precisao padrao das medidas lineares: 1 mm (0,001 m). */
export const MEASURE_DECIMALS = 3;
export const MEASURE_FACTOR = 10 ** MEASURE_DECIMALS;

/** Converte a entrada em metros, aceitando tanto virgula quanto ponto. */
export function parseMeasure(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (value === null || value === undefined || value === "") return 0;
  const parsed = parseFloat(`${value}`.trim().replace(",", "."));
  return Number.isFinite(parsed) ? parsed : 0;
}

/** Normaliza a medida para o menor incremento suportado (1 mm). */
export function roundMeasure(value) {
  return Math.round(parseMeasure(value) * MEASURE_FACTOR) / MEASURE_FACTOR;
}

/** Exibe 2 casas normalmente e a terceira somente quando houver milimetros. */
export function formatMeasure(value, decimalSeparator = ".") {
  const formatted = roundMeasure(value)
    .toFixed(MEASURE_DECIMALS)
    .replace(/0$/, "");
  return decimalSeparator === "," ? formatted.replace(".", ",") : formatted;
}
